import { ButtonComponent, ModalComponent, PaperComponent } from "@/components";
import { CurrencyConverter, IMAGES, WEB_COLORS } from "@/lib/constants";
import { VIDEOS } from "@/lib/constants/Videos";
import {
  Grid,
  Stack,
  Box,
  Typography,
  Card,
  CardMedia,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import Image from "next/image";
import React, { useState, useRef, useEffect } from "react";

const OFFERS_UPGARDE = [
  {
    id: 1,
    icon: IMAGES.timerDark,
    alt: "Instant eligibility check",
    text: (
      <>
        Instant
        <br /> eligibility check
      </>
    ),
  },
  {
    id: 2,
    icon: IMAGES.bankDark,
    alt: "Starting at 17.9% p.a",
    text: (
      <>
        Starting at
        <br />
        17.9% p.a
      </>
    ),
  },
  {
    id: 3,
    icon: IMAGES.docIcon,
    alt: "No documents required",
    text: (
      <>
        No documents
        <br />
        required
      </>
    ),
  },
];
const UpgradeOfferPopup = ({
  open,
  handleModal,
  handleContinueWithUpgrade,
}) => {
  const theme = useTheme();
  const isBelowMd = useMediaQuery(theme.breakpoints.down("md"));
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const videoRef = useRef(null);

  useEffect(() => {
    if (!open) return;

    const video = videoRef.current;
    if (!video) return;

    video.muted = false;
    video.currentTime = 0;

    video.play().catch(() => {});
  }, [open]);

  return (
    <ModalComponent
      maxWidth={isBelowMd ? "sm" : "sm"}
      open={open}
      contentSx={{
        p: { xs: 0, md: 0 },
      }}
      closeButtonRequired={false}
    >
      <Stack>
        <Box
          sx={{
            backgroundImage: "linear-gradient(90deg, #004135 0%, #00A788 100%)",
            borderTopLeftRadius: { md: "16px", xs: "8px" },
            borderTopRightRadius: { md: "16px", xs: "8px" },
            textAlign: "center",
            boxShadow: "0 0 12px rgba(0, 167, 136, 0.25)",
          }}
        >
          <Typography
            textAlign={"center"}
            fontWeight={400}
            fontSize={{ xs: "12px", md: "16px" }}
            lineHeight={{ xs: "16.5px", md: "100%" }}
            color={WEB_COLORS.white}
            p={{ xs: 0.5, md: 1 }}
          >
            Among{" "}
            <Typography
              sx={{ display: "inline" }}
              fontWeight={700}
              fontSize={{ xs: "12px", md: "16px" }}
              lineHeight={{ xs: "16.5px", md: "100%" }}
              color={WEB_COLORS.white}
            >
              Top 1%{" "}
            </Typography>
            eligible users
          </Typography>
          <PaperComponent
            paperStyle={{
              borderRadius: { xs: "8px", md: "16px" },
              px: 0,
              py: 0,
              m: 0,
            }}
            elevation={0}
          >
            <Stack
              sx={{
                bgcolor: "#fff",
                borderRadius: { xs: "8px", md: "16px" },
                overflow: "hidden",
                p: 0,
                my: 0,
              }}
            >
              <Box
                sx={{
                  position: "relative",
                  width: "100%",
                  height: { xs: "100%", sm: 200 },
                  overflow: "hidden",
                }}
              >
                {/* {!isMobile && ( */}
                <Box
                  component="img"
                  src={IMAGES.upgradeOfferBackground?.src}
                  //   alt="background"
                  sx={{
                    position: "absolute",
                    inset: 0,
                    width: "100%",
                    height: { xs: "100%", sm: "80%" },
                    objectFit: "cover",
                    zIndex: 1,
                  }}
                />
                {/* )} */}
                {/* <Box
                  ref={videoRef}
                  component="video"
                  src={VIDEOS.upgradeOffer}
                  autoPlay
                  playsInline
                /> */}
                {/* ; */}
                <Box
                  ref={videoRef}
                  component="video"
                  src={VIDEOS.upgradeOffer}
                  autoPlay
                  playsInline
                  preload="auto"
                  onEnded={(event) => {
                    const video = event.currentTarget;

                    video.muted = true;
                    video.currentTime = 0;

                    video.play().catch(() => {
                      // Ignore autoplay rejection after first play.
                    });
                  }}
                  sx={{
                    position: "relative",
                    zIndex: 2,
                    width: "100%",
                    height: "100%",
                    objectFit: { xs: "cover", sm: "contain" },
                    objectPosition: { xs: "50% 0px" },
                    background: "transparent",
                  }}
                />
              </Box>
            </Stack>
            <Stack p={0} m={0} justifyContent={"center"} alignItems={"center"}>
              <Stack p={{ xs: 1, md: -2 }} m={0} width={{ sm: 390 }}>
                <Typography
                  textAlign={"center"}
                  fontWeight={400}
                  fontSize={{ xs: "14px", md: "18px" }}
                  color={WEB_COLORS.blackHeading}
                  mt={{ sm: -0.5, md: -1.5 }}
                >
                  Get upto
                </Typography>
                <Typography
                  textAlign={"center"}
                  fontWeight={700}
                  fontSize={{ xs: "36px", md: "48px" }}
                  color={WEB_COLORS.darkTeal}
                  mt={{ md: -1 }}
                >
                  {CurrencyConverter(700000)}
                </Typography>
                <Typography
                  sx={{
                    width: { md: 300 },
                    mx: "auto",
                    textAlign: "center",
                    mt: { md: -0.5 },
                  }}
                  fontWeight={400}
                  fontSize={{ xs: "12px", md: "16px" }}
                  lineHeight={{ xs: "16px", md: "24px" }}
                >
                  Verify your{" "}
                  <Typography
                    sx={{ display: "inline" }}
                    fontWeight={500}
                    fontSize={{ xs: "12px", md: "16px" }}
                    lineHeight={{ xs: "16px", md: "24px" }}
                    color={"#2B6B35"}
                  >
                    salary account{" "}
                  </Typography>
                  or{" "}
                  <Typography
                    sx={{ display: "inline" }}
                    fontWeight={500}
                    fontSize={{ xs: "12px", md: "16px" }}
                    lineHeight={{ xs: "16px", md: "24px" }}
                    color={"#2B6B35"}
                  >
                    account with most transactions
                  </Typography>
                </Typography>

                <Grid
                  container
                  justifyContent="center"
                  alignItems="flex-start"
                  color="#3F3F3F"
                  columnSpacing={{ xs: 0, sm: 2 }}
                  sx={{ mt: 1 }}
                >
                  {OFFERS_UPGARDE.map((item) => (
                    <Grid item xs={4} key={item.id}>
                      <Stack
                        alignItems="center"
                        justifyContent="flex-start"
                        sx={{
                          minHeight: 76,
                        }}
                      >
                        <Box
                          sx={{
                            width: { sm: 38, xs: 28 },
                            height: { sm: 38, xs: 28 },
                            border: "1px solid #E5EAE9",
                            backgroundColor: "#EAF3F3",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            mb: 1,
                          }}
                        >
                          <Image
                            src={item.icon}
                            alt={item.alt}
                            width={isMobile ? 16 : 20}
                            height={isMobile ? 16 : 20}
                            loading="lazy"
                          />
                        </Box>

                        <Typography
                          textAlign="center"
                          fontWeight={400}
                          fontSize={{ xs: "10px", md: "10px" }}
                          lineHeight={{ xs: "120%", sm: "14px" }}
                          color="#1F1F1F"
                        >
                          {item.text}
                        </Typography>
                      </Stack>
                    </Grid>
                  ))}
                </Grid>
              </Stack>
            </Stack>
            <Stack
              flexDirection={{ sm: "row", xs: "column" }}
              justifyContent={"center"}
              alignItems={"center"}
              gap={1}
              mt={{ xs: -1 }}
              p={{ md: 2, xs: 1 }}
            >
              <Box sx={{ order: { xs: 1, sm: 2 }, width: "100%" }}>
                <ButtonComponent
                  stackWidth={"100%"}
                  onClick={() => {
                    localStorage.setItem("upgradeOfferPopup", "N");
                    handleContinueWithUpgrade();
                  }}
                >
                  Upgrade Offer
                </ButtonComponent>
              </Box>
              <Box sx={{ order: { xs: 2, sm: 1 }, width: "100%" }}>
                <ButtonComponent
                  stackWidth={"100%"}
                  onClick={() => {
                    localStorage.setItem("upgradeOfferPopup", "N");
                    handleModal();
                  }}
                  buttonStyle={{
                    border: { sm: "1px solid #003128", xs: "none" },
                    color: "#003128",
                    boxShadow: {
                      xs: "none",
                    },
                    backgroundColor: "#fff",
                    "&:hover": {
                      backgroundColor: WEB_COLORS.lightGrey,
                      boxShadow: {
                        xs: "2px 2px 2px 2px rgba(0, 0, 0, 0.3)",
                        sm: "none",
                      },
                    },
                  }}
                >
                  Continue with existing offer
                </ButtonComponent>
              </Box>
            </Stack>
          </PaperComponent>
        </Box>
      </Stack>
    </ModalComponent>
  );
};

export default UpgradeOfferPopup;
